import MetaText from '../../elements/text/MetaText'

export default MetaText
